import { Badge } from "@/components/ui/badge"
import { useUser } from "@/hooks/useUser"
import { useService, useServiceEventListener } from "@/hooks/useService"
import { InboxIcon } from "lucide-react"
import { useCallback, useEffect, useState } from "react"
import {
  NOTIFICATION_SERVICE_IDENT,
  type INotificationService,
  type NotificationCreatedEvent,
  type NotificationUpdatedEvent,
  type NotificationDeletedEvent,
  RPC_EVENT_NOTIFICATION_CREATED_IDENT,
  RPC_EVENT_NOTIFICATION_UPDATED_IDENT,
  RPC_EVENT_NOTIFICATION_DELETED_IDENT,
} from "@bloomstack/apis/services/INotificationService"
import type { Notification } from "@bloomstack/apis/notifications"

export const UnreadNotificationsBadge = () => {
  const [user] = useUser();
  const [unreadCount, setUnreadCount] = useState(0)
  const notificationService = useService<INotificationService>(NOTIFICATION_SERVICE_IDENT);

  const fetchUnreadCount = useCallback(async () => {
    const result = await notificationService.countUnread();
    if (result.success) { setUnreadCount(result.result); }
  }, [notificationService]);

  useServiceEventListener<NotificationCreatedEvent>(
    RPC_EVENT_NOTIFICATION_CREATED_IDENT,
    (notification: Notification) => { if (notification.userId === user?.id) fetchUnreadCount(); },
    [user, fetchUnreadCount]
  );

  useServiceEventListener<NotificationUpdatedEvent>(
    RPC_EVENT_NOTIFICATION_UPDATED_IDENT,
    (notification: Notification) => { if (notification.userId === user?.id) fetchUnreadCount(); },
    [user, fetchUnreadCount]
  );

  useServiceEventListener<NotificationDeletedEvent>(
    RPC_EVENT_NOTIFICATION_DELETED_IDENT,
    (userId: string) => { if (userId === user?.id) fetchUnreadCount(); },
    [user, fetchUnreadCount]
  );

  useEffect(() => {
    fetchUnreadCount();
  }, []);

  return (
    <Badge count={unreadCount} badgeClassName="bg-red-500 text-white" bounce>
      <InboxIcon className="w-8" />
    </Badge>
  )
}